/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const UrgentFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.463 21.3877H3.53681C2.3959 21.3877 1.67266 20.1645 2.22248 19.1648L10.6856 3.77737C11.2555 2.7412 12.7443 2.7412 13.3142 3.77737L21.7773 19.1648C22.3271 20.1645 21.6039 21.3877 20.463 21.3877ZM12.7499 9.38769V14.3877H11.2499V9.38769H12.7499ZM11.9999 18.3877C12.5522 18.3877 12.9999 17.94 12.9999 17.3877C12.9999 16.8354 12.5522 16.3877 11.9999 16.3877C11.4476 16.3877 10.9999 16.8354 10.9999 17.3877C10.9999 17.94 11.4476 18.3877 11.9999 18.3877Z"
                        fill={color}
                    />
                </svg>
        );
    };
